import React, { useState,useContext, useEffect } from 'react';
import { Tooltip } from '@mui/material';
import JisInput from '../../components/controls/jisInput';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import JisTable from '../../components/controls/jisTable';
import JisDropdown from '../../components/controls/jisDropdown';
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialogForm from '../../components/formdialog';



function ManageRole() {
  const pagecode="managerole";
  const defaultRole={id:0, name: '', description: '', isAsistance:false, isParent:false, parentRoleId:0 , landing:'dashboard'};
  const defaultObj ={id:0,isSla:false, isOnMenu:true, isActive:true,autoRouting:true};
  const {  activePage, token, filingType, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
  const [role, setRole] = useState(defaultRole);
  const [agree, setAgree] = useState(false);
  const [selected, setSelected] = useState({});
  const [tab, setTab] = useState('role');
  const [loading, setLoading] =useState(false);
  const [err,setErr] = useState('');
  const [roles, setRoles] = useState([]);
  const [parentOptions, setParentOptions] = useState([]);
  const [activeRole, setActiveRole]=useState({});
  const [screens, setScreens] = useState([]);
  const [screenTabs, setScreenTabs] = useState([]);
  const [screenActions, setScreenActions] = useState([]);
  const [screen, setScreen]= useState(defaultObj);
  const [screenTab, setScreenTab]= useState(defaultObj);
  const [screenAction, setScreenAction] = useState(defaultObj)
  
  const [screenOptions, setScreenOptions] = useState([]);
  const [tabOptions, setTabOptions] = useState([]);
  const [parentScreenOptions, setParentScreenOptions] = useState([]);


  const [screenSide, setScreenSide]=useState('screen');

  const [roleScreens, setRoleScreens] =useState([]);
  const [roleTabs, setRoleTabs] =useState([]);
  const [roleActions, setRoleActions] =useState([]);
 

  const [page,setPage] = useState(null);
const [isDialog, setIsDialog] = useState(false);

  useEffect(() => {
   // setActivePage({title:'Manage Role'});
    loadPage();
    onLoad();
  }, []);

  async function loadPage() {
      const data = await Constants.onScreenDetails(pagecode,token);
      setPage(data);
      
    }

     const pulltypes=[
        {label:'User Specific',value:"specific" },
        {label:'Division based', value:"division"},
        {label:'All', value:"All"},
    ] 
   useEffect(() => {
        const parentRoleOptions = roles
      .filter(role => role.isParent)
      .map(role => ({
        value: role.id,
        label: role.name,
      }));
      setParentOptions(parentRoleOptions);
  }, [roles]);

  useEffect(() => {
        const screenOptions = screens
      .filter(sc => (sc.isActive && !sc.isParent)) //load only actual screen
      .map(sc => ({
        value: sc.id,
        label: sc.title,
      }));
      setScreenOptions(screenOptions);


      const parentScreenOptions = screens
      .filter(sc => (sc.isActive && sc.isParent))
      .map(sc => ({
        value: sc.id,
        label: sc.title,
      }));
      setParentScreenOptions(parentScreenOptions);


  }, [screens]);

useEffect(() => {
  if(screenAction.screenId==null) return;
        const tabOptions = screenTabs
      .filter(sc => (sc.isActive && sc.screenId==screenAction.screenId))
      .map(sc => ({
        value: sc.id,
        label: sc.title,
      }));
      setTabOptions(tabOptions);
  }, [screenAction.screenId ]); // will be only when the screenTab change


    useEffect(() => {
    
      if(tab=='screen' || tab=='manage'){
        if(screens.length==0){
          //load screen, it has not been loaded before
          onLoadScreen();
        }
      }
  }, [tab]);

      useEffect(() => {
    console.log('changes happen to roleScreens')
    console.log(roleScreens);
     
  }, [roleScreens]);

  const getTab=(screenid)=>{
       const list = screenTabs
      .filter(sc => (sc.isActive && sc.screenId==screenid)) //load only actual screen
      ;
      return list
  }
  const getActionsByScreen=(screenid)=>{
     const list = screenActions
      .filter(sc => (sc.isActive && sc.screenId==screenid && sc.tabId==null)) //load only actual screen
      ;
      return list;
  }
  const getActionsByTab=(tabid)=>{
 const list = screenActions
      .filter(sc => (sc.tabId==tabid )) //load only actual screen
      ;
      return list;
  }

  const onLoad= async()=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/profile/roles`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
       setRoles(data);
       
      } catch (error) {
        setLoading(false);
        console.error(error);
        
      }
}

 const onLoadScreen= async()=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/profile/screens`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
       setScreens(data.screens);
       setScreenTabs(data.tabs);
       setScreenActions(data.actions);
       
      } catch (error) {
        setLoading(false);
        console.error(error);
        
      }
}

const onLoadPermision= async(r)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/profile/permission/${r.id}`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
       setRoleScreens(data.screens);
       setRoleTabs(data.tabs);
       setRoleActions(data.actions);
       
      } catch (error) {
        setLoading(false);
        console.error(error);
        
      }
}

  const getParentRoleName = (id) => {
    const parent = roles.find(r => r.id === id);
    return parent ? parent.name : '';
  };

  const toggleCheckbox = (key, childrenKeys = []) => {
    setSelected((prev) => {
      const newSelected = { ...prev };
      const isChecked = !prev[key];

      // Set the parent
      newSelected[key] = isChecked;

      // Set all children (tabs, actions)
      childrenKeys.forEach(childKey => {
        newSelected[childKey] = isChecked;
      });

      return newSelected;
    });
  };

  
  const renderActions = (actions) => {
    return actions.map((action, i) => {
      const actionKey = `${i}.${action.code}`;
      return (
        <div key={i} style={{ marginLeft: '30px' }}>
          <JisCheckbox
            label={action.name}
            value={isScreenAction(action.id)}
            onChange={() => onCheckAction({roleId:activeRole.id,actionId:action.id})}
          />
        </div>
      );
    });
  };

  const handleSave = () => {
    const selectedScreens = [];
    const selectedTabs = [];
    const selectedActions = [];
  
    Object.keys(selected).forEach((key) => {
      if (selected[key]) {
        const parts = key.split('.');
  
        if (parts.length === 1) {
          // screen
          selectedScreens.push(parts[0]);
        } else if (parts.length === 2) {
          const [screenId, second] = parts;
  
          if (second.startsWith('tab')) {
            // tab under screen
            selectedTabs.push(second);
          } else {
            // action under screen directly
            selectedActions.push(second);
          }
        } else if (parts.length === 3) {
          // action under tab
          const actionCode = parts[2];
          selectedActions.push(actionCode);
        }
      }
    });
  
   
  };
  

  
  const screen_columns = [
    { key: 'id', label: '#' },
    { key: 'title', label: 'Title' },
    { key: 'code', label: 'Code' },
    { key: 'url', label: 'Url Link' },
    { key: 'isTab', label: 'Has Tab' },
     { key: 'isActive', label: 'Status' },
    { key: 'isParent', label: 'Is Parent' },
    { key: 'helpLink', label: 'Help Link' },
    { key: 'note', label: 'Note' },
    { key: 'icon', label: 'Icon' },
    { key: 'rank', label: 'Rank' },
  ];

    const screentab_columns = [
    { key: 'id', label: '#' },
    { key: 'title', label: 'Title' },
    { key: 'code', label: 'Code' },
    { key: 'isActive', label: 'Status' },
    { key: 'helpLink', label: 'Help Link' },
    { key: 'note', label: 'Note' },
    { key: 'icon', label: 'Icon' },

  ];
  const screenaction_columns = [
    { key: 'id', label: '#' },
    { key: 'name', label: 'Name' },
    { key: 'code', label: 'Code' },
    { key: 'isActive', label: 'Status' },
    { key: 'helpLink', label: 'Help Link' },
    { key: 'note', label: 'Note' },
    { key: 'icon', label: 'Icon' },

  ];

  const onEditRole=(row) =>{
    setIsDialog(true);
      setRole(row);
  }
  const onEditScreen=(row) =>{
    setIsDialog(true);
      setScreen(row);
  }
  const onEditScreenTab=(row) =>{
      setScreenTab(row);
  }
  const onEditScreenAction=(row) =>{
      setScreenAction(row);
  }


   const screen_actions = [
    {
      label: 'Edit',
      icon: 'edit',
      onClick: onEditScreen,
      color: 'primary',
    }
  ];
  const screentab_actions = [
    {
      label: 'Edit',
      icon: 'edit',
      onClick: onEditScreenTab,
      color: 'primary',
    }
  ];

  const screenaction_actions = [
    {
      label: 'Edit',
      icon: 'edit',
      onClick: onEditScreenAction,
      color: 'primary',
    }
  ];

  const upsertRole = (prevRoles, newRole) => {
    const index = prevRoles.findIndex(role => role.id === newRole.id);
    if (index !== -1) {
      // Update existing role
      return prevRoles.map(role => role.id === newRole.id ? { ...role, ...newRole } : role);
    } else {
      // Insert new role
      return [...prevRoles, newRole];
    }
  };

   const upsertObject = (prevObjs, newObj) => {
    const index = prevObjs.findIndex(obj => obj.id === newObj.id);
    if (index !== -1) {
      // Update existing role
      return prevObjs.map(obj => obj.id === newObj.id ? { ...obj, ...newObj } : obj);
    } else {
      // Insert new role
      return [...prevObjs, newObj];
    }
  };

  const RoleChange = (e) => {
    setRole({...role, [e.target.name]: e.target.value})
}
  const onScreenChange = (e) => {
    setScreen({...screen, [e.target.name]: e.target.value})
}
 const onScreenTabChange = (e) => {
    setScreenTab({...screenTab, [e.target.name]: e.target.value})
}
const onScreenActionChange = (e) => {
    setScreenAction({...screenAction, [e.target.name]: e.target.value})
}

const onSaveRole=async(e) =>{
  e.preventDefault()
        setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/role`, {
            method: 'POST',
            body:JSON.stringify(role) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setLoading(false);
          console.log(data);
          setRoles(prev => upsertRole(prev, data.role));
          setRole(defaultRole);
          setIsDialog(false);
          setAlert({title:'Save Role',subtitle:'Role Saved successfully',open:true});
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}

const onSelectRole = async(e)=>{
  console.log('role selected');
  console.log(e);
  setActiveRole(e);
  onLoadPermision(e);
}

const onSaveScreen =async(e) =>{
  console.log(screen);
   e.preventDefault()
        setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/screen`, {
            method: 'POST',
            body:JSON.stringify(screen) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setIsDialog(false);
          setLoading(false);
          console.log(data);
          setScreens(prev => upsertObject(prev, data.screen));
          setScreen({id:0,title:'',code:'',isActive:true,isTab:false,isParent:false,isOnMenu:true,isSla:false,
            url:'',icon:'',rank:1,helpLink:'',note:''
          });
          setAlert({title:'Save Role',subtitle:'Screen Saved successfully',open:true});
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}
const onSaveScreenTab =async(e) =>{
  console.log(screen);
   e.preventDefault()
        setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/screentab`, {
            method: 'POST',
            body:JSON.stringify(screenTab) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setLoading(false);
          console.log(data);
          setIsDialog(false);
          setScreenTabs(prev => upsertObject(prev, data.screentab));
          setScreenTab(defaultObj);
          setAlert({title:'Save Tab',subtitle:'Tab Saved successfully',open:true});

        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}



const isScreen=(id)=>{

return roleScreens.some(item => (item.screenId === id  && item.isActive));
}
const isScreenTab=(id)=>{
return roleTabs.some(item => (item.tabId === id && item.isActive));
}
const isScreenAction=(id)=>{
return roleActions.some(item => (item.actionId === id  && item.isActive));
}

const onSaveScreenAction =async(e) =>{
  e.preventDefault()
        setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/screenaction`, {
            method: 'POST',
            body:JSON.stringify(screenAction) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setLoading(false);
          console.log(data);
          setIsDialog(false);
          setScreenActions(prev => upsertObject(prev, data.screenaction));
          setScreenAction(defaultObj);
          setAlert({title:'Save Action',subtitle:'Screen Action Saved successfully',open:true});
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}

const onCheckScreen=async(sc)=>{
       setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/rolescreen`, {
            method: 'POST',
            body:JSON.stringify(sc) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setLoading(false);
          setRoleScreens(prev => upsertObject(prev, data.rolescreen));
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}

const onCheckTab=async(st)=>{
  setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/roletab`, {
            method: 'POST',
            body:JSON.stringify(st) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setLoading(false);
          setRoleTabs(prev => upsertObject(prev, data.roletab));
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}
const onCheckAction=async(sa)=>{
setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/profile/roleaction`, {
            method: 'POST',
            body:JSON.stringify(sa) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await resp.json();
          if (data.code == -10) {
            setLoading(false);
            setIsExpired(true);
            return;
          }
          setLoading(false);
          setRoleActions(prev => upsertObject(prev, data.roleaction));
        } catch (error) {
          setLoading(false);
          console.error(error);
          setErr(Constants.serverErr);
         // onMove();
        }
}

    const onAdd=()=>{
      setIsDialog(true);
    }
    const onClose=()=>{
      setIsDialog(false);
    }

  return (
    <div style={{ padding: '20px' }}>
      <div className='tab_body'>
        <div className='tab_section' style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <JisTabButton code="createeditrole" isActive={tab=='role'}  title="Create Role" data={page}  onClick={()=> setTab('role')}/>
          <JisTabButton code="managetab" isActive={tab=='manage'}  title="Role Permission" data={page}  onClick={()=> setTab('manage')}/>
          <JisTabButton code="managescreen" isActive={tab=='screen'}  title="Role Permission" data={page}  onClick={()=> setTab('screen')}/>

        </div>

   {tab=='role' && <div className='tab_view'>
          <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Role</JisButton> </div>
         
         <div className='table'>
            <div class="section-cases">
                <span>Roles</span><span className='total'>{roles?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th className="col-id">SN</th>
                        <th className="col-title">Name</th>
                        <th className="col-title">Description</th>
                        <th className="col-medium">Filing Type</th>
                        <th className="col-action">Pull Type</th>
                        <th className="col-action">Action</th>
                    </tr>
                </thead>
                <tbody>
                   { roles.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.name}</td>
                        <td>{g.description}</td>
                        <td>{g.filingType}</td>
                        <td>{g.pullType}</td>
                        <td><JisButton variant='plain' onClick={()=>onEditRole(g)}>Edit</JisButton>
                        <JisButton variant={'default'} onClick={(row) => console.log('Delete:', row)}>Delete</JisButton>
                        </td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>

        </div>}     
   
        {tab=='manage' && <div className="tab_view" style={{ display: 'flex', marginTop: '30px', gap: '30px' }}>
          <div className='maxheight' style={{ width: '30%', borderRightColor:'var(--primary)', borderRightStyle:'solid', borderRightWidth:2, padding:16, maxHeight:800 }}>
            <h4>Roles</h4>
            <div className="role-list">
              {roles.map(role => (
                <div key={role.id} className={`role-card selected ${role.id==activeRole.id?'active':''}`} 
             
                onClick={()=>onSelectRole(role)}>
                  <div className="role-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h5>{role.name}</h5>
                    <div className="role-icons">
                      {role.isParent && (
                        <Tooltip title="This role is a parent role">
                          <span><DynamicIcon iname="star" color="gold" /></span>
                        </Tooltip>
                      )}
                      {role.isAsistance && (
                        <Tooltip title="This role assists a parent role">
                          <span><DynamicIcon iname="group" color="blue" /></span>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div>{role.description}</div>
                  
                  {role.isAsistance && (
                    <small style={{ fontStyle: 'italic' }}>
                      Parent Role: {getParentRoleName(role.parentRoleId)}
                    </small>
                  )}
                </div>
              ))}
            </div>
          </div>
<div style={{ flex: 1 }}>
  <h4>Permissions</h4>
  <div  style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            
            {screens.map((screen,index) => {
             
              return (
                <div key={index}  style={{
                  border: '2px solid #4CAF50', // Green border color
                  borderRadius: '8px',
                  padding: '10px',
                  width: '250px',
                  display: 'flex',
                  flexDirection: 'column', // Ensure the content stacks properly
                  height: '100%', // Allow items to stretch
                }}>
                  <JisCheckbox
                    label={<strong>{screen.title}</strong>}
                    value={isScreen(screen.id)}
                    onChange={() => onCheckScreen({roleId:activeRole.id,screenId: screen.id})}
                  />

                  {/* Screen actions (if no tabs) */}
                  { renderActions(getActionsByScreen(screen.id))}

                  {/* Tabs and actions */}
                  {
                    getTab(screen.id).map((tab) => {
                      const tabKey = `${tab.id}`;
                      const tabActionKeys = tab.actions ? tab.actions.map(action => `${tabKey}.${action.code}`) : [];
                      return (
                        <div key={tabKey} style={{ marginLeft: '20px' }}>
                          <JisCheckbox
                            label={tab.title}
                            value={isScreenTab(tab.id)}
                            onChange={() => onCheckTab({roleId:activeRole.id,tabId: tab.id})}
                          />
                          
                          { renderActions(getActionsByTab(tab.id), tabKey)}
                        </div>
                      );
                    })}
                </div>
              );
            })}
          </div>

</div>
          
        </div>} 
      {tab=="screen" && <div  className='tab_view'>
       <div className='side-tabs-container'>
         <div className='side-tabs' >
          <div className={`selected ${screenSide=='screen'?'active':''}`} onClick={()=>setScreenSide('screen')}>Screens</div>
          <div className={`selected ${screenSide=='tab'?'active':''}`} onClick={()=>setScreenSide('tab')}>Tabs</div>
          <div className={`selected ${screenSide=='action'?'active':''}`}  onClick={()=>setScreenSide('action')}>Actions</div>
        </div>
       {screenSide=='screen' && 
       <div className='tab-content'><h2>Screen</h2> 
                 <div style={{textAlign:'right'}}><JisButton onClick={onAdd}>Add Screen</JisButton></div>
                  <JisTable columns={screen_columns} data={screens} actions={screen_actions} />
                </div>} 
                {screenSide=='tab' && 
                <div className='tab-content'><h2>Tab</h2> 
               <div style={{textAlign:'right'}}><JisButton onClick={onAdd}>Add Tab</JisButton></div>
                  <JisTable columns={screentab_columns} data={screenTabs} actions={screentab_actions} />
                </div>}
               {screenSide=='action' && 
               <div className='tab-content'><h2>Actions</h2> 
                 <div style={{textAlign:'right'}}><JisButton onClick={onAdd}>Add Action</JisButton></div>
                 <JisTable columns={screenaction_columns} data={screenActions} actions={screenaction_actions} /> 
                </div>} 
              
       </div>
       
        </div>}  
      </div>

     {isDialog && tab=='screen' && screenSide=='screen' && <JisDialogForm title="Screen" onClose={onClose}>
         <form  onSubmit={onSaveScreen}>
                    <div style={{display:'flex'}}>
                      
                      <div  className="input-group">
                        <label>Screen Title </label>
                        <div className='input-wrapper'>
                          <input
                      placeholder='Screen Title'
                      name="title"
                      value={screen.title}
                      onChange={onScreenChange}
                      required={true}  />
                        </div>
                      </div>
                  
                      <div  className="input-group">
                        <label>Screen Code </label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='This Code used programatically. '
                      name="code"
                      value={screen.code}
                      onChange={onScreenChange}
                      required={true}  />
                        </div>
                      </div>
                    </div>
                  <div  style={{display:'flex'}}>
                <JisCheckbox label="Active Screen" value={screen.isActive}
                 onChange={(e)=> setScreen({...screen, isActive:e})} />
                  <JisCheckbox label="It has Tab(s)?" value={screen.isTab}
                 onChange={(e)=> setScreen({...screen, isTab:e})} />
                 <JisCheckbox label="This Screen is Parent?" value={screen.isParent}
                 onChange={(e)=> setScreen({...screen, isParent:e})} /> 
                  </div>
                  <div>
                    <JisCheckbox label="This Screen apprear on menu" value={screen.isOnMenu}
                 onChange={(e)=> setScreen({...screen, isOnMenu:e})} /> 
                <JisCheckbox label="Auto routing" value={screen.autoRouting}
                 onChange={(e)=> setScreen({...screen, autoRouting:e})} />
                 
                  </div>
                  <div style={{display:'flex'}}>
                    <JisCheckbox label="Check this screen if SLA is Applicable?" value={screen.isSla}
                 onChange={(e)=> setScreen({...screen, isSla:e})} /> 

               {screen.isSla &&  <div  className="input-group">
                        <label>SLA Duration in days </label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='The Duration in days'
                      name="slaDuration"
                      value={screen.slaDuration}
                      onChange={onScreenChange}
                      required={true}  />
                        </div>
                      </div>} 
                  </div>
                 
                    <div  className="input-group">
                        <label>Url </label>
                        <div className='input-wrapper'>
                         <input
                        placeholder='Navigate to Url. '
                        name="url"
                        value={screen.url}
                        onChange={onScreenChange}  />
                        </div>
                      </div>
                  
                      <div  style={{display:'flex'}}>
                    <div  className="input-group">
                        <label>Icon </label>
                        <div className='input-wrapper'>
                    <input
                      placeholder='Icon to display. '
                      name="icon"
                      value={screen.icon}
                      onChange={onScreenChange}  />
                        </div>
                      </div>
                       <div  className="input-group">
                        <label> Rank</label>
                        <div className='input-wrapper'>
                        <input

                      placeholder='Position of the screen '
                      name="rank"
                      type="number"
                      value={screen.rank}
                      onChange={onScreenChange}  />
                        </div>
                      </div>

                      
                      </div>
                  <div  className="input-group">
                        <label> HelpLink</label>
                        <div className='input-wrapper'>
                        <input
                          placeholder='Full help link '
                          name="helpLink"
                          value={screen.helpLink}
                          onChange={onScreenChange}  />
                        </div>
                      </div>
                  <div  className="input-group">
                        <label> Note</label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='Brief explanation of the screen '
                      name="note"
                      value={screen.note}
                      onChange={onScreenChange}  />
                        </div>
                      </div>
                  
                    

                      <JisCheckbox label="Has Parent" value={screen.hasParent}
                 onChange={(e)=> setScreen({...screen, hasParent:e})} /> 

                 {(screen.hasParent || screen.parentId!=null) &&
                 <div className="select-group">
                <label> Parent Link <span className="required">*</span> </label>
                <select name="parentId" value={screen.parentId} required={true} onChange={onScreenChange} >
                    <option value="">Select </option>
                    {parentScreenOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                    ))}
                </select>
                </div> 
                    } 
                 

                  <JisButton type="submit" iconPosition='left' icon="alarm-clock-check">{screen.id>0?'Update':'Save'} Screen</JisButton>
                  

                  </form>
      </JisDialogForm>} 
     {isDialog && tab=='screen' && screenSide=='tab' &&  <JisDialogForm title="Screen Tab" onClose={onClose}>
          <form  onSubmit={onSaveScreenTab}>
                  <div  style={{display:'flex'}}>
                    <div  className="input-group">
                        <label> Tab Title</label>
                        <div className='input-wrapper'>
                        <input
                        placeholder='Tab Title'
                        name="title"
                        value={screenTab.title}
                        onChange={onScreenTabChange}
                        required={true}  />
                        </div>
                      </div>
                    
                    <div  className="input-group">
                        <label> Tab Code</label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='This Code used programatically. '
                      name="code"
                      value={screenTab.code}
                      onChange={onScreenTabChange}
                      required={true}  />
                        </div>
                      </div>
                  </div>
                  
                  <div  style={{display:'flex'}}>
                    <JisCheckbox label="Active Screen" value={screenTab.isActive}
                 onChange={(e)=> setScreenTab({...screenTab, isActive:e})} />
                      <div  className="input-group">
                        <label>Icon </label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='Icon to display. '
                      name="icon"
                      value={screenTab.icon}
                      onChange={onScreenTabChange}  />
                        </div>
                      </div>
                  
                  </div>
                 <div  className="input-group">
                        <label> Help Link</label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='Full help link '
                      name="helpLink"
                      value={screenTab.helpLink}
                      onChange={onScreenTabChange}  />
                        </div>
                      </div>
                  <div  className="input-group">
                        <label>Note </label>
                        <div className='input-wrapper'>
                    <input
                      placeholder='Brief explanation of the screen '
                      name="note"
                      value={screenTab.note}
                      onChange={onScreenTabChange}  />
                        </div>
                      </div>
                  
                  
                  <JisDropdown name="screenId" label="Associated Screen" value={screenTab.screenId} onChange={onScreenTabChange} options={screenOptions} required/>
                  <JisButton type="submit" iconPosition='left' icon="alarm-clock-check">{screen.id>0?'Update':'Save'} Screen Tab</JisButton>

                  </form>
      </JisDialogForm>} 
      {isDialog && tab=='screen' && screenSide=='action' &&  <JisDialogForm title="Screen Action" onClose={onClose}>
<form  onSubmit={onSaveScreenAction}>
                  <div  style={{display:'flex'}}>
                    <div  className="input-group">
                        <label> Action Name</label>
                        <div className='input-wrapper'>
                          <input
                          placeholder='Action Name'
                          name="name"
                          value={screenAction.name}
                          onChange={onScreenActionChange}
                          required={true}  />
                        </div>
                      </div>
                    <div  className="input-group">
                        <label>Action Code </label>
                        <div className='input-wrapper'>
                          <input
                          label=""
                          placeholder='This Code used programatically. '
                          name="code"
                          value={screenAction.code}
                          onChange={onScreenActionChange}
                          required={true}  />
                        </div>
                      </div>
                  
                  </div>
                  <div>
                    <JisCheckbox label="Active Screen Action" value={screenAction.isActive}
                 onChange={(e)=> setScreenAction({...screenAction, isActive:e})} />
<div  className="input-group">
                        <label> Icon</label>
                        <div className='input-wrapper'>
<input
                      placeholder='Icon to display. '
                      name="icon"
                      value={screenAction.icon}
                      onChange={onScreenActionChange}  />
                        </div>
                      </div>
                  
                  </div>
                 <div  className="input-group">
                        <label>HelpLink </label>
                        <div className='input-wrapper'>
                      <input
                      placeholder='Full help link '
                      name="helpLink"
                      value={screenAction.helpLink}
                      onChange={onScreenActionChange}  />
                        </div>
                      </div>
                  
                  <div  className="input-group">
                        <label> Note</label>
                        <div className='input-wrapper'>
                        <input
                        placeholder='Brief explanation of the screen '
                        name="note"
                        value={screenAction.note}
                        onChange={onScreenActionChange}  />
                        </div>
                      </div>
                  
                  
                  <div  style={{display:'flex'}}>
                    <JisDropdown name="screenId" label="Associated Screen" value={screenAction.screenId} onChange={onScreenActionChange} options={screenOptions} required />
                      <JisCheckbox label="Action Associated to a Tab" value={screenAction.isforTab} onChange={(e)=>setScreenAction({...screenAction, isforTab:e})} />
                      {screenAction.isforTab && <JisDropdown name="tabId" label="Associated Tab" value={screenAction.tabId} onChange={onScreenActionChange} options={tabOptions} />}    
                  </div>
                      
                    


                  <JisButton type="submit" iconPosition='left' icon="alarm-clock-check">{screen.id>0?'Update':'Save'} Screen Action</JisButton>

                  </form>
      </JisDialogForm>} 

    {isDialog && tab=='role' && <JisDialogForm title="Role" onClose={onClose}>
<form onSubmit={onSaveRole} style={{marginBottom:16, flex:1}}>
      
            <div  className="input-group">
                <label> Role Name</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    label=""
                    placeholder='The role name/Title'
                    name="name"
                    value={role.name}
                    onChange={RoleChange}
                    required={true}
                  />
                </div>
            </div>

            <div  className="input-group">
                <label> Role Description</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='The role description'
                    name="description"
                    value={role.description}
                    required={true}
                    onChange={RoleChange}
                  />
                </div>
            </div>

             <div  className="input-group">
                <label> Landing Screen</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='The Landing Screen'
                    name="landing"
                    value={role.landing}
                    required={true}
                    onChange={RoleChange}
                  />
                </div>
            </div>
            
      <div className="select-group">
                            <label> Filing Case Type <span className="required">*</span> </label>
                            <select name="filingTypeId" value={role.filingTypeId} required={true} onChange={RoleChange} >
                                <option value="">Select </option>
                                {filingType.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>

             <div className="select-group">
                            <label> Data Pull Type <span className="required">*</span> </label>
                            <select name="pullType" value={role.pullType} required={true} onChange={RoleChange} >
                                <option value="">Select </option>
                                {pulltypes.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>               
          <JisCheckbox
                label="This role an Assistance role like Judicial Assistant"
                value={role.isAsistance}
                onChange={(e)=>setRole({...role, isAsistance:e})}
                name="isAsistance"
                
              />
              <JisCheckbox
                label="This role a Parent role like Judge"
                value={role.isParent}
                onChange={(e)=>setRole({...role, isParent:e})}
                name="isParent"
               
              />
          <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
              
              
          </div>
         {role.isAsistance && <div>
         
            <div className="select-group">
                            <label> Parent Role <span className="required">*</span> </label>
                            <select  name="parentRoleId" value={role.parentRoleId} onChange={RoleChange} >
                                <option value="">Select </option>
                                {parentOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>

          </div>} 

          

          <JisButton type="submit"  iconPosition='left' icon="save" isRoleBased={true} code="saverole" data={page}>{role.id>0?'Update':'Save'} Roles</JisButton>

          
    </form>
      </JisDialogForm>}  
    {loading && <BackLoader />}  
    </div>
  );
}

export default ManageRole;
